import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/registerServiceWorker";
import { isNativeApp } from "@/lib/nativeBridge";

// Android 16 / iOS edge-to-edge: flag the native shell so CSS can apply
// safe-area insets (Capacitor 8 renders behind the system bars).
if (isNativeApp()) document.body.classList.add("native-app");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
